import { Effect, Layer } from "effect";
import { panelKeyboardFocusFailure } from "./panel-keyboard-model.ts";
import { PanelKeyboardFocusIo } from "./panel-keyboard-service.ts";

const find = (container: HTMLElement, id: string) => [...container.querySelectorAll<HTMLElement>("[id]")].find(node => node.id === id);
export const PanelKeyboardFocusIoLive = Layer.succeed(PanelKeyboardFocusIo, {
  focus: (container, host, request, preventDefault) => Effect.try({ try: () => {
    if (!container.isConnected || !host.isConnected) return;
    if (request._tag === "Tab") {
      const previous = find(container, `${request.id}-close`) ?? find(container, request.id);
      previous?.focus();
      return;
    }
    const panel = find(host, request.id);
    if (panel && !panel.hidden) {
      preventDefault();
      panel.focus();
    }
  }, catch: panelKeyboardFocusFailure })
});
